import {
  IChartData,
  TCasingRendererDimensions,
  TWellDetails,
  TWellSchematic,
  ISectionType,
  ISection,
} from '../utils/types';
import { calculateDepthLabels } from './calculate-depth-labels';
import { calculateGrid } from './calculate-grid';
import { calculateLithology } from './calculate-lithology';
import { calculateMeta } from './calculate-meta';
import { calculateSections } from './calculate-sections';

export const calculateChartData = (
  wellSchematics: TWellSchematic[],
  wellDetail: TWellDetails,
  dimensions: TCasingRendererDimensions,
  sectionTypes: ISectionType[],
  casingSections: ISection[],
  units: { [unit: string]: any },
): IChartData => {
  const meta = calculateMeta(wellSchematics, wellDetail, units, dimensions, sectionTypes);
  const grid = calculateGrid(meta);

  const sections = calculateSections(wellSchematics, meta, sectionTypes, casingSections);
  const lithology = calculateLithology(wellDetail, meta);

  const depthLabels = calculateDepthLabels(sections, meta);

  const data: IChartData = {
    sections,
    meta,
    grid,
    background: lithology,
    depthLabels,
  };
  return data;
};
